import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customNumber'
})
export class CustomNumberPipe implements PipeTransform {
  readonly MILLION = 1000000;
  readonly THOUSAND = 1000;

  constructor() {
  }

  transform(amount: string): string {
    const value = Number(amount);
    if (value >= this.MILLION) {
      return `${this.formatAmount(value, this.MILLION)}M`;
    } else if (value >= this.THOUSAND && value < this.MILLION) {
      return `${this.formatAmount(value, this.THOUSAND)}K`;
    }
    return this.formatCurrencyWithoutDecimalPart(value);
  }

  formatAmount(value: number, divider: number): string {
    return this.formatCurrencyWithoutDecimalPart(Math.floor(value / divider));
  }

  formatCurrencyWithoutDecimalPart(amount: number): string {
    const decimalSeparator = Number('1.2').toLocaleString().substr(1, 1);
    const amountWithCommas = amount.toLocaleString();
    // format only int part of number
    const parts = String(amountWithCommas).split(decimalSeparator);
    return parts[0];
  }
}
